import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ContactSearchModal } from 'src/app/core/models/contact/contacts-search.model';
import { GlobalComponent } from 'src/app/global-component';
import { SearchResultModel } from 'src/app/core/models/query/search-result-model';
import { ContactBaseModel } from 'src/app/core/models/contact/contact-base.model';
import { BaseListService } from './base-list.service';

export class ContactListState extends ContactSearchModal {
  isEnabled?: boolean;
}

@Injectable({ providedIn: 'root' })
export class ContactListService extends BaseListService {

  defaultContactListState: ContactListState = {
    sortColumnDirective: '',
    sortDirectionDirective: '',
    number: '',
    lastName: '',
    fullName: '',
    pageSize: GlobalComponent.defaultPagingInfo.pageSize,
    pageIndex: 0,
    startIndex: 0,
    email: '',
    companyName: '',
    sortColumn: '',
    sortDirection: '',
    searchTerm: '',
    isEnabled: undefined
  };

  private _resultItems$ = new BehaviorSubject<ContactBaseModel[]>([]);
  
  protected override _state: ContactListState = { ...this.defaultContactListState };

  constructor(
    private myFileApiService: MyfileApiService) {
    super();
    this._search$.pipe(
      tap(() => this._loading$.next(true)),
      switchMap(() => this._search()),
      tap(() => this._loading$.next(false))
    ).subscribe((result: any) => {
      this._resultItems$.next(result.items);
      this._total$.next(result.count);
    });
  }

  get resultItems$() { return this._resultItems$.asObservable(); }
  get fullName() { return `${this._state.fullName}`; }
  get companyName() { return `${this._state.companyName}`; }

  set fullName(fullName: string) { this._set({ fullName }); }
  set companyName(companyName: string) { this._set({ companyName }); }
  set isEnabled(isEnabled: any) { this._set({ isEnabled }); }

  protected _search(): Observable<SearchResultModel<ContactBaseModel>|undefined> {

    this.validateStartIndex();

    this._state.sortColumn = this.titleCaseWord(this._state.sortColumnDirective) as string;

    return this.myFileApiService.getContacts(this._state);
  }

  clearListService(){
    this._state = {...this.defaultContactListState};
    this._resultItems$.next(new Array<ContactBaseModel>());
    this._total$.next(0);
  }

}
